import {Divider, ListFilterHeader} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TeamFilterCreatedAtSection} from './TeamFilterCreatedAtSection';
import {TeamFilterRoleSection} from './TeamFilterRoleSection';
import {TeamFilterStatusSection} from './TeamFilterStatusSection';
import {DEFAULT_TEAM_FILTER_STATE} from '../../config/team-filter.config';
import {isTeamFilterActive} from '../../utils';

import type {TeamFilterState} from '../../config/team-filter.config';
import type {FirmUserRoleStatus} from '@sollapay/enums';
import type {FC} from 'react';

export interface TeamFilterMenuProps {
  filter: TeamFilterState;
  onChange: (filter: TeamFilterState) => void;
}

export const TeamFilterMenu: FC<TeamFilterMenuProps> = ({filter, onChange}) => {
  const {t} = useTranslation('team');

  const handleStatusChange = (statuses: FirmUserRoleStatus[]) => onChange({...filter, statuses});
  const handleRoleChange = (roleKeys: string[]) => onChange({...filter, roleKeys});
  const handleCreatedAtChange = (createdAt: TeamFilterState['createdAt']) =>
    onChange({...filter, createdAt});

  return (
    <div data-slot="team-filter-menu" className="flex flex-col py-2">
      <ListFilterHeader
        title={t('filter.title')}
        clearLabel={t('filter.clearAll')}
        isActive={isTeamFilterActive(filter)}
        onClearAll={() => onChange(DEFAULT_TEAM_FILTER_STATE)}
      />
      <TeamFilterStatusSection statuses={filter.statuses} onChange={handleStatusChange} />
      <Divider className="my-1" />
      <TeamFilterRoleSection roleKeys={filter.roleKeys} onChange={handleRoleChange} />
      <Divider className="my-1" />
      <TeamFilterCreatedAtSection createdAt={filter.createdAt} onChange={handleCreatedAtChange} />
    </div>
  );
};
